import PropTypes from 'prop-types';
import {
  Box,
  Card,
  CardContent,
  Grid,
  Typography
} from '@material-ui/core';

const ProductCard = ({ product, ...rest }) => (
  <button className="buttonPlus" type="submit">
    <Card
      sx={{
        display: 'flex',
        flexDirection: 'column',
        height: '150px',
        width: '200px',
      }}
      {...rest}
    >
      <CardContent>
        <Typography
          align="center"
          color="textPrimary"
          gutterBottom
          variant="h4"
        >
          {product.collectible.id}
        </Typography>
      </CardContent>
      <Box sx={{ flexGrow: 1 }} />
      <Box sx={{ p: 2 }}>
        <Grid
          container
          spacing={2}
          sx={{ justifyContent: 'space-between' }}
        >
        </Grid>
      </Box>
    </Card>
  </button>
);

ProductCard.propTypes = {
  product: PropTypes.object.isRequired
};

export default ProductCard;
